import React from "react";
import { Link, useNavigation } from "react-router-dom";
import Services from "../../Shared/Services/Services";
import Slider from "../Slider/Slider";
import "./Home.css";
import Lottie from "lottie-react";
import delivery from "../../../deliveryFood.json";
import TopReviews from "./TopReviews";
import { TypeAnimation } from "react-type-animation";
import Loader from "../../Shared/Loader/Loader";

const Home = () => {
   const navigation = useNavigation();

   if (navigation.state === "loading") {
      return <Loader />;
   }

   return (
      <section className="home-top">
         <Slider />
         <div className="mt-delivery border-danger header mx-auto rounded-4 px-0 py-2 d-flex flex-lg-row-reverse justify-content-between gap-4 gap-md-5 align-items-center py-3 py-sm-0 header-bg">
            <div className="lottie">
               <Lottie animationData={delivery} loop={true} />
            </div>

            <div className="text-start w-header mt-4 mt-md-5">
               <h2 className="mb-3 mt-md-5 fw-bol my-text-shado">
                  What is your Delivery Today?
               </h2>

               <p className="text-secondary fs-my-9 lh-my-1">
                  <TypeAnimation
                     sequence={[
                        "Welcome to my Food For You website. This is a fully functional, fully responsive, full stack (MERN) service review website. You can visit my website, choose your favorite food items and make a delivery order by making an online payment. Don't forget to give your precious review and inspire others to visit my website, make orders, and give their valuable reviews also.",
                        3000,
                     ]}
                     speed={65}
                     cursor={false}
                     repeat={Infinity}
                  />
               </p>
            </div>
         </div>

         <Services />

         <div className="d-flex justify-content-center">
            <div>
               <Link
                  to="/services"
                  className="btn btn-primary fw-semibold bg-gradient px-3 py-2 view-all mb-5"
               >
                  See All Services
               </Link>
            </div>
         </div>

         <TopReviews />
      </section>
   );
};

export default Home;
